'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/_function-bind@1.1.2@function-bind/index.js
// module id = GLLF
// module chunks = 0